import { FC, ReactNode } from 'react';
import { ConfigProvider, theme, Grid } from 'antd';
import { useTheme } from '../contexts/themeContext';

const { useBreakpoint } = Grid;

interface ThemeConfigProps {
  children: ReactNode;
}

const ThemeConfig: FC<ThemeConfigProps> = ({ children }) => {
  const screens = useBreakpoint();
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const { theme: currentTheme } = useTheme();
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'Roboto Flex',
          colorPrimary: '#003862',
          colorBorderSecondary: currentTheme === 'dark' ? '#303030' : '#e1e1e1',
          colorLink: '#003862',
          colorWarning: '#f5bf36',
          colorText: '#475569',
          colorTextHeading: '#1E293B',
          colorTextLabel: '#334155',
          colorTextPlaceholder: '#94a3b8',
        },
        components: {
          Card: {
            // colorBorder: "@colorBorderSecondary"
          },
          Button: {
            colorPrimary: '#f5bf36',
            colorPrimaryHover: '#e5aa2b',
            primaryColor: '#000',
            primaryShadow: 'none',
            fontSizeSM: 10,
            fontSizeLG: 14,
            fontWeight: '400',
            controlHeightLG: 42,
            paddingContentHorizontalLG: 12,
          },

          Typography: {
            fontSizeHeading1: screens.md ? 34 : 22,
            fontSizeHeading2: screens.md ? 28 : 20,
            fontSizeHeading3: screens.md ? 20 : 18,
            fontSizeHeading4: screens.md ? 18 : 16,
            fontSizeHeading5: screens.md ? 16 : 14,
            lineHeightHeading1: 1.4, // tighter line-height
            lineHeightHeading2: 1.35,
            fontWeightStrong: 600,
            colorTextHeading: currentTheme === 'dark' ? '#ffffff' : '#1E293B',
            fontFamily: 'Mona Sans, Arial',
          },

          Menu: {
            itemActiveBg: 'transparent',
            itemSelectedBg: 'transparent',
            darkItemSelectedColor: '#f5bf36',
            darkGroupTitleColor: '#fff',
            colorLinkActive: '#fff',
            groupTitleColor: 'red',
          },
          Input: {
            controlHeightSM: screens.md ? 42 : 38,
            controlHeightLG: screens.md ? 52 : 46,
            inputFontSizeLG: screens.md ? 16 : 14,
            fontSize: screens.md ? 17 : 15,
          },

          Select: {
            controlHeightSM: screens.md ? 32 : 28,
            controlHeightLG: screens.md ? 52 : 46,
            optionHeight: screens.md ? 48 : 40,
            fontSize: screens.md ? 17 : 15,
            fontSizeSM: 12,
            optionPadding: screens.md ? '13px 12px' : '10px 12px',
            optionSelectedBg: '#e8f0f7',
            optionSelectedColor: '#003862',
          },
          DatePicker: {
            controlHeightSM: screens.md ? 42 : 38,
            controlHeightLG: screens.md ? 52 : 46,
          },
          Steps: {
            colorPrimary: '#003862',
            colorTextLightSolid: '#ffffff',
          },
        },

        algorithm: currentTheme === 'dark' ? darkAlgorithm : defaultAlgorithm,
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default ThemeConfig;
